// Loads the presale's checkout state and keeps the visitor on a step the presale allows.
import { useOrderCheckout } from '@/stores/order-checkout'
import {
	getCheckoutRedirectStep,
	getCheckoutStepFromPath,
} from '@/utils/order-checkout'

const LOAD_ERROR_MESSAGES: Record<number, string> = {
	403: `Sorry, you don't have access to this order.`,
	404: `Sorry, we couldn't find this order.`,
}

export default defineNuxtRouteMiddleware(async (to) => {
	const orderCheckout = useOrderCheckout()
	const uuid = to.params.uuid as string

	if (orderCheckout.checkout?.uuid !== uuid) {
		try {
			await orderCheckout.loadCheckout(uuid)
		} catch (error) {
			const statusCode =
				(error as { statusCode?: number })?.statusCode ?? 500

			throw createError({
				statusCode,
				statusMessage:
					LOAD_ERROR_MESSAGES[statusCode] ??
					'Sorry, we could not load your order. Please try again.',
				fatal: true,
			})
		}
	}

	const checkout = orderCheckout.checkout!

	if (checkout.status === 'cancelled' || checkout.status === 'inactive') {
		throw createError({
			statusCode: 410,
			statusMessage: 'Sorry, this order is no longer available.',
			fatal: true,
		})
	}

	const redirectStep = getCheckoutRedirectStep(
		checkout,
		getCheckoutStepFromPath(to.path)
	)

	if (redirectStep) {
		return navigateTo(`/checkout/${uuid}/${redirectStep}`, {
			replace: true,
		})
	}
})
